module.exports = __webpack_public_path__ + "assets/illus-smart-asset.e96458ab.svg";